__turbopack_context__.v({
  "className": "J9BUdG_className",
  "variable": "J9BUdG_variable",
});
